import { getAccessToken } from "@/lib/api/auth-token";
import { fetchCurrentUser } from "@/lib/api/me-api";
import { storeAuthProfile } from "@/lib/auth/profile";
import { storeTokensFromHandoff } from "@/lib/auth/token-session";
import type { AuthApiUser } from "@/types/auth-api-types";
import type { AuthProfile } from "@/types/auth-types";

function profileFromUser(user: AuthApiUser): AuthProfile {
  return {
    name: user.name,
    email: user.email,
  };
}

/** GET /api/me — load and persist current user. */
export async function fetchAndStoreCurrentUser(): Promise<AuthApiUser> {
  const user = await fetchCurrentUser();
  storeAuthProfile(profileFromUser(user));
  return user;
}

export function hasStoredAccessToken(): boolean {
  return Boolean(getAccessToken()?.trim());
}

/** @deprecated Use storeTokensFromHandoff */
export function storeAccessTokenFromHandoff(token: string): void {
  storeTokensFromHandoff(token);
}

export { storeTokensFromHandoff };
